import { useApolloClient } from '@apollo/client';
import { useField } from 'formik';
import { gql } from '@yi/core';

import { analytics, extractStringParamsFromUrlSearch, nr } from '~/common';
import { useOnMount } from '~/src/components/hooks';

interface Props {
  fieldName: string;
  onChanged: (email: string) => void;
}

// Load email address from query string into form field
const useSetFormEmailFromUrl = ({ fieldName, onChanged }: Props) => {
  const apolloClient = useApolloClient();

  const [, , { setValue }] = useField({
    name: fieldName,
  });

  useOnMount(() => {
    (async () => {
      try {
        const { email, hash } = extractStringParamsFromUrlSearch();

        if (email) {
          setValue(email);
          onChanged(email);
        } else if (hash) {
          const { error, errors, data } = await apolloClient.query<
            gql.typesClient.Query_DecodeEmail,
            gql.typesClient.Query_DecodeEmailVariables
          >({ query: gql.Query_DecodeEmail, variables: { hash } });

          if (error) throw error;
          if (errors) throw new Error(errors.join(', '));

          setValue(data.decodeEmail);
          onChanged(data.decodeEmail);
          analytics.sendEmailCaptureEvent(data.decodeEmail);
        }
      } catch (e) {
        nr.noticeError(`Error setting form email from URL: ${e}`);
      }
    })();
  });
};

export const SetFormEmailFromUrl: React.FC<Props> = props => {
  useSetFormEmailFromUrl(props);
  return null;
};
